import Online from './Online/index.vue'
import POS from './POS/index.vue'

export default [
  { path: '/info/online', component: Online },
  { path: '/info/pos', component: POS }
]